// extracted by mini-css-extract-plugin
export default {"blob":"Blob_blob__a5D45"};